import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { debounce } from "lodash";

import Stars from '../../../Common/Stars';
import { LoadingIcon } from '../../../Common/Loading_Icon';

import ProfileOverviewTab from "./Overlay/OL_Tab_ProfileOverview";
import ProfileBookingsTab from "./Overlay/OL_Tab_ProfileBookings";
import ProfileSurveysTab from "./Overlay/OL_Tab_ProfileSurveys";
import ProfileMediaTab from "./Overlay/OL_Tab_ProfileMedia";
import ReactTooltip from 'react-tooltip';
import { setProfileDb } from "../../../../Actions/dataActions";
import { setOverlay, closePullout } from "../../../../Actions/stakeholderActions";
import { checkCredentials } from '../../../../Helpers/checkCredentials';
import { VCIcon, DivisionIcon } from '../../../Common/Buttons/TypeIcons';
import { constants } from '../../../../Helpers/Constants';
import { UserProfile, TagProfile, EditDefault, UserDeactivate, UserApproved, Phone, Mail, UserDeactivateRed, ActionCheck, ActionClose, UserProfileResizable } from '../../../Common/Buttons/Icons';
import { formatPhone } from '../../../../Helpers/PhoneHelper';
import { Trans } from 'react-i18next';
import StatusCard from '../../../Common/DesignSystem/StatusCard';
import {GridContainer, GridItem} from '../../../Common/DesignSystem/Grid';
import { P3, Heading6, CaptionMedium, P3Bold, P3Link, Heading5, CaptionSmall, P2Bold, InputLabel } from '../../../Common/DesignSystem/Text';
import Button from '../../../Common/DesignSystem/Button';
import colours from '../../../Common/DesignSystem/Colours';
import Icon from '../../../Common/DesignSystem/Icons/Icon';
import { DropdownItem, Input } from '../../../Common/DesignSystem/Input';
import i18n from '../../../../i18n';
import FileUploadCard from '../../../Common/DesignSystem/FileUploadCard';
import moment from 'moment';

class ProfileOverlay extends Component {
    constructor(props) {    
        super(props);

        //overlay ref
        this.overlayRef = React.createRef();
        this.contentRef = React.createRef();

        this.state = {
            profile_details: {},
            current_tab: "Overview",
            loaded_profile: true,
            loading_main: true,
            edit: false,
            profile_form: {},
            media_user: false,
            notes_box: false,
            windowWidth: window.innerWidth,
            containerHeight: 48
        };

        this.onEditInternalTag = this.onEditInternalTag.bind(this);
        this.onDeactivate = debounce(this.onDeactivate.bind(this), 500);
        this.onReactivate = debounce(this.onReactivate.bind(this), 500);
        this.onApprove = debounce(this.onApprove.bind(this), 500);
        this.onReject = debounce(this.onReject.bind(this), 500);
        this.handleResize = this.handleResize.bind(this);
        this.getOffset = this.getOffset.bind(this);

        this.setTab = this.setTab.bind(this);
        this.toggleNotesBox = this.toggleNotesBox.bind(this);
        this.updateUserNotes = this.updateUserNotes.bind(this);
        this.submitNotesBox = this.submitNotesBox.bind(this);

        this.divisionsAndVcs = this.divisionsAndVcs.bind(this);
    }

    handleResize() {
        if (this.contentRef.current) {
            let docHeight = this.contentRef.current.offsetHeight + 48; 
            if (docHeight !== null && docHeight !== undefined) { 
                this.setState({windowWidth: window.innerWidth, containerHeight: docHeight});
                return;
            } 
        }
        else {
            this.setState({windowWidth: window.innerWidth, containerHeight: 48});
        }
    }

    getOffset() {
        if (this.overlayRef.current) {
            return this.overlayRef.current.scrollTop;
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        //Check if the details of the car are in the database just in case
        this.props.dispatch(closePullout())
        if (this.props.match.params.tab && (this.props.match.params.tab === "Overview" || this.props.match.params.tab === "Bookings" ||  this.props.match.params.tab === "Surveys" || this.props.match.params.tab === "Media")) {
            this.setState({
                current_tab: this.props.match.params.tab
            })
        }
        if (this.props.match.params.profile_id in this.props.data.profile_db && this.props.data.profile_db[this.props.match.params.profile_id].sh_vmh_access != undefined) {
            this.setState({
                profile_details: {"profile": this.props.data.profile_db[this.props.match.params.profile_id]},
                loaded_profile: false
            })
        }
    
        var self = this;
        axios.get('/ajax/profile/' + this.props.match.params.profile_id)
        .then(function(response) {
            checkCredentials(response)
            self.props.dispatch(setProfileDb([response?.data.profile], self.props.data.profile_db))
            self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response?.data))
            var profile_form = self.state.profile_form;

            for (var i = 0; i < response?.data.profile.sh_vmh_access.length; i++) {
                if (response?.data.profile.sh_vmh_access[i].stakeholder.Category === constants.sh_divisions.public_affairs){
                    self.setState({
                        media_user: true
                    })
                }
            }

            if (response?.data.profile.profilenotes.length > 0) {
                profile_form['profile_notes'] =  response?.data.profile.profilenotes[0].Notes
            }

            self.setState({
                profile_details: response?.data,
                loading_main: false,
                loading_profile: false,
                profile_form: profile_form
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        });

        setTimeout(()=> {
            this.handleResize();
        },500)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    setTab(tab_name) {
        this.setState({
            current_tab: tab_name
        })

        var base_url = (this.props.match.url).split('/')
        this.props.history.push("/" + base_url[1] + "/" + base_url[2] + "/" + base_url[3] + "/" + tab_name);
    }

    renderTab() {
        if (this.state.current_tab === "Overview") {
            return(
                <ProfileOverviewTab history={this.props.history} match={this.props.match} location={this.props.location} profile_details={this.props.stakeholder.current_profile_details} media_user={this.state.media_user} setTab={this.setTab}/>
            )
        } else if (this.state.current_tab === "Bookings") {
            return(
                <ProfileBookingsTab history={this.props.history} match={this.props.match} location={this.props.location} profile_details={this.props.stakeholder.current_profile_details}/>
            )
        } else if (this.state.current_tab === "Surveys" && this.props.stakeholder.current_profile_details.user_type == "user") {
            return(
                <ProfileSurveysTab history={this.props.history} match={this.props.match} location={this.props.location} profile_details={this.props.stakeholder.current_profile_details}/>
            )
        } else if (this.state.current_tab === "Media") {
            return(
                <ProfileMediaTab history={this.props.history} match={this.props.match} location={this.props.location} profile_details={this.props.stakeholder.current_profile_details} />
            )
        }
    }

    editProfile() {
        this.setState({
            notes_box: false
        })
        var base_url = (this.props.match.url).split('/')
        this.props.history.push("/" + base_url[1] + "/" + base_url[2] + "/" + base_url[3] + "/Edit");
    }

    stopEditProfile() {
        this.setState({
            notes_box: false
        })
        this.props.history.goBack();
    }

    onEditInternalTag(e, props) {
        e.stopPropagation();
        
        this.props.history.push(this.props.match.url + '/internaltag/' + this.props.match.params.profile_id + '/edit');
    }

    onDeactivate(e, props) {
        e.stopPropagation();

        this.props.history.push(this.props.match.url + '/deactivateprofile/' + this.props.match.params.profile_id);
    }

    onReactivate(e, props) {
        e.stopPropagation();

        var self = this;
        axios.post('/ajax/profile/' + this.props.match.params.profile_id + '/activate')
        .then(function(response) {
            checkCredentials(response);
            showStatusMsg(response?.data.message, 'success');

            axios.get('/ajax/profile/' + self.props.match.params.profile_id)
            .then(function(response2) {
                self.props.dispatch(setProfileDb([response2.data.profile], self.props.data.profile_db))
                self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    onApprove(e) {
        e.stopPropagation();

        axios.post('/ajax/profile/' + this.props.match.params.profile_id + '/approve')
        .then((response) => {
    
            axios.get('/ajax/profile/' + this.props.match.params.profile_id)
            .then(function(response2) {
                props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
            })
            .catch(function(error) {
                if(error.response2.status == 401){
                    showStatusMsg(error.response2.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response2.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            showStatusMsg(response?.data.message, 'success');
            if (self.props.closeModal) self.props.closeModal();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    onReject(e) {
        if (self.props.closeModal) self.props.closeModal();
        e.stopPropagation();
        this.props.history.push(this.props.match.url + '/rejectuser/' + this.props.match.params.profile_id);
    }

    divisionsAndVcs() {
        var profile = this.props.data.profile_db[this.props.match.params.profile_id];
        var divisions = [];
        var vmhs = [];

        //To prevent duplicates
        var current_divisions = {};
        var current_vmhs = {};
        if ('sh_vmh_access' in profile) {
            profile.sh_vmh_access.map((access) => {
                if (! (access.stakeholder.SH_ID in current_divisions)) {
                    current_divisions[access.stakeholder.SH_ID] = true
                    divisions.push(
                        <div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
                            <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>
                                {DivisionIcon(access.stakeholder, 20, undefined, undefined, true)}
                                <P3Bold>{access.stakeholder.Company} {access.stakeholder.Division} Division</P3Bold>
                            </div>
                        </div>
                    )
                }

                if (! (access.vmh.VMH_ID in current_vmhs)) {
                    current_vmhs[access.vmh.VMH_ID] = true;
                    vmhs.push(
                        // <div className="overlay_header_info_access_item" style={{alignItems: 'center', paddingTop: 10}}>
                        //     {VCIcon(access.vmh)}
                        //     <P3Bold>{access.vmh.Display_Name + " - " + access.vmh.Display_City}</P3Bold>
                        // </div>
                        <div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
                            <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>
                                {VCIcon(access.vmh, 20, undefined, undefined, true)}
                                <P3Bold>{access.vmh.Display_Name + " - " + access.vmh.Display_City}</P3Bold>
                            </div>
                        </div>
                    )
                }
            })
        }

        return (
            <div style={this.state.windowWidth <= 1456 ? 
                {flex: 1, flexDirection: 'column', justifyContent: 'space-between', display: 'flex'}
                : {flex: 1, flexDirection: 'row', justifyContent: 'space-between', display: 'flex'}}
            >
                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                    <CaptionMedium style={{color: colours.primary.grey02, marginBottom: 4}}>FACILITY:</CaptionMedium>
                    <div>{vmhs}</div>
                </div>
                <div style={this.state.windowWidth <= 1456 ? {display: 'flex', flex: 1, flexDirection: 'column', marginTop: 16} : {display: 'flex', flex: 1, flexDirection: 'column'}}>
                    <CaptionMedium style={{color: colours.primary.grey02, marginBottom: 4}}>POOL:</CaptionMedium>
                    <div>{divisions}</div>
                </div>
            </div>
        )

        // var total_access = divisions.concat(vmhs)

        // return total_access;
    }
    
    toggleNotesBox() {
        this.setState({
            notes_box: !this.state.notes_box
        })
    }

    updateUserNotes(e) {
        var profile_form = this.state.profile_form
        profile_form['profile_notes'] = e.target.value

        this.setState({
            profile_form,
            notes_box: true
        })
    }

    submitNotesBox() {
        var self = this;

        axios.post('/ajax/profile/' + this.props.match.params.profile_id + '/updateNotes', this.state.profile_form)
        .then(function(response) {
            showStatusMsg(response?.data.message, 'success');
            
            axios.get('/ajax/profile/' + self.props.match.params.profile_id)
            .then(function(response) {
                checkCredentials(response)
                self.props.dispatch(setProfileDb([response?.data.profile], self.props.data.profile_db))
                self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response?.data))
                var profile_form = self.state.profile_form;
    
                for (var i = 0; i < response?.data.profile.sh_vmh_access.length; i++) {
                    if (response?.data.profile.sh_vmh_access[i].stakeholder.Category === constants.sh_divisions.public_affairs){
                        self.setState({
                            media_user: true
                        })
                    }
                }
    
                if (response?.data.profile.profilenotes.length > 0) {
                    profile_form['profile_notes'] =  response?.data.profile.profilenotes[0].Notes
                }
    
                self.setState({
                    profile_details: response?.data,
                    loading_main: false,
                    loading_profile: false,
                    profile_form, profile_form
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
        this.setState({
            notes_box: false
        })
    }

    render(props) {
        if (this.state.loading_profile || ! ("profile" in this.props.stakeholder.current_profile_details) || ! (this.props.match.params.profile_id in this.props.data.profile_db)) {
            return (
                <LoadingIcon />
            )
        } else {
            var profile = this.props.data.profile_db[this.props.match.params.profile_id];
            let iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};

            if (this.props.match.params.tab === "Edit") {
                return (
                    <>
                    <ReactTooltip className="ds-tooltip" effect="solid" type="light" offset={{top: this.getOffset()}} />
                    <div className="main_overlay" id="add-or-edit-vehicle-main-overlay" style={{backgroundColor: 'white', display: 'flex', flexDirection: 'column'}} ref={this.overlayRef} onScroll={()=> {
                        ReactTooltip.rebuild();
                    }}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', padding: '8px 4px'}}>
                            <div style={{justifyContent: 'center', alignItems: 'flex-end', paddingLeft: 36, display: 'flex', flex: 1}}>
                                <Heading6>
                                    Edit User
                                </Heading6>
                            </div>
                            <div className="overlay_header_close include-mobile" onClick={this.props.history.goBack} >
                                &times;
                            </div>
                        </div>
                        <div className="overlay_header" ref={this.contentRef}>
                            <div className="overlay_header_info_container">
                                <div style={{flexGrow: 1}}>
                                    <GridContainer justifyContent='space-evenly' spacing={3} direction={this.state.windowWidth <= 768 ? "column" : "row"}>
                                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 6} className="overlay_header_grid_item">
                                            <div className="overlay_header_bordered" style={{flexGrow: 0}}>
                                                <GridContainer justifyContent="flex-start" spacing={3} direction="row">
                                                    <GridItem xs={this.state.windowWidth <= 768 ? 12 : 6}>
                                                        <>
                                                            <div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
                                                                <InputLabel>{i18n.t('User Image')}</InputLabel>
                                                            </div>
                                                            <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                                                                <FileUploadCard 
                                                                    imageSrc={
                                                                        "photo" in profile && profile.photo !== '' && profile.photo !== null ? 
                                                                        'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/' + profile.photo
                                                                        : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png' } 
                                                                    imageName={profile.First_Name + ' ' + profile.Last_Name}
                                                                    squareImg
                                                                />
                                                            </div>
                                                        </>
                                                    </GridItem>
                                                </GridContainer>
                                                <div style={{display: 'flex', flexDirection: 'row', flex: this.state.windowWidth <= 768 ? 2 : 4, flexWrap: 'wrap'}}>
                                                    <div className="full-width f1">
                                                        <Input label="Name" name="name" value={profile.First_Name + " " + profile.Last_Name} readOnly/>
                                                    </div>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'row', flex: this.state.windowWidth <= 768 ? 1 : 2, flexWrap: 'wrap'}}>
                                                    <div className="half-width-mr f1 mr-24">
                                                        <Input label="Position" name="position" value={profile.Title} readOnly/>
                                                    </div>
                                                    <div className="half-width f1">
                                                        <Input label="Company" name="company" value={profile.Company} readOnly/>
                                                    </div>
                                                </div>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 6} className="overlay_header_grid_item">
                                            <div className="overlay_header_bordered" style={{flexGrow: 0}}>
                                                <div className="profile-info-container">
                                                    <div style={{flexDirection: 'column', flex: 1, display: 'flex'}}>
                                                        <P2Bold style={{padding: '8px 0px'}}>
                                                            User Settings
                                                        </P2Bold>
                                                        <div style={{display: 'flex', flexDirection: 'row', flex: this.state.windowWidth <= 768 ? 1 : 2, flexWrap: 'wrap'}}>
                                                            <GridContainer justifyContent="flex-start" spacing={this.state.windowWidth <= 768 ? 0 : 3} direction="row">
                                                                <GridItem xs={this.state.windowWidth <= 768 ? 12 : 6}>
                                                                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: 16}}>
                                                                        <div className="ds-input-outer-container">
                                                                            <div className="ds-input-label" style={{marginLeft: 16, marginBottom: 4,  display: 'flex', flexDirection: 'row'}}>
                                                                                <InputLabel>{i18n.t('Tier')}</InputLabel>
                                                                            </div>
                                                                            <div className="ds-input">
                                                                                <Stars star={profile.sh_vmh_access[0].tier.Rank} mutable updateForm={this.setStarValue} type={"User"}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </GridItem>
                                                            </GridContainer>
                                                        </div>
                                                        <div className="overlay_header_bordered" style={{flexGrow: 0}}>
                                                            <div className="full-width f1">
                                                                <Input label="Facility" name="facility" value={profile.sh_vmh_access[0].vmh.Display_Name + ' ' + profile.sh_vmh_access[0].vmh.Display_City}/>
                                                            </div>
                                                            <div className="full-width f1">
                                                                <Input label="Pool" name="pool" value={profile.sh_vmh_access[0].stakeholder.Company + ' ' + profile.sh_vmh_access[0].stakeholder.Division}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            </div>
                        </div>
                        <div className={"ds-sticky-bottom-button-container" + (((this.state.containerHeight) < (window.innerHeight * 0.9)) ? " nonsticky" : "")}>
                            <Button secondary label="Cancel" medium style={{width: 172, marginRight: this.state.windowWidth <= 768 ? 0 : 24}} onClick={this.props.history.goBack}/>
                            <Button primary label="Save Changes" medium style={{width: 172}} onClick={this.submitEdit}/>
                        </div>
                    </div>
                </>
                )
            } else {
                return (
                    <div className="main_overlay" id="add-or-edit-vehicle-main-overlay">
                        <div className = "overlay_responsive_close">
                            <span onClick={this.props.closeModal}><Trans>Close</Trans> <span className = "ml-8" style = {{fontSize: "18px"}}>&times;</span></span>
                        </div>
                        <div style={{backgroundColor: 'white', display: 'flex', flex: 1, justifyContent: 'flex-end', flexDirection: 'row'}}>
                            <div className="overlay_header_close" onClick={this.props.closeModal} >
                                &times;
                            </div>
                        </div>
                        <div className="overlay_header">
                            <div className="overlay_header_info_container" style={{paddingLeft: 16, paddingRight: 16}}>
                                <div style={{flexGrow: 1}}>
                                    <GridContainer justifyContent='space-evenly' spacing={3} direction={this.state.windowWidth <= 768 ? "column" : "row"}>
                                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 6} className="overlay_header_grid_item">
                                            <div className="overlay_header_bordered">
                                                <div className="profile-info-container">
                                                    <div className="mobile-hidden-f1">
                                                        <div>
                                                        {
                                                            profile.Is_User === 1 ?
                                                                "photo" in profile && profile.photo && "Link" in profile.photo && profile.photo.Link !== "" ?
                                                                    <span><img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/' + profile.photo.Link} className="rounded-image"/></span>
                                                                : <span className="rounded-image">{UserProfileResizable({size: '100%'})}</span>
                                                            : <span className="rounded-image">{TagProfile("fill-primary", "white", "100%", "100%")}</span>
                                                        }
                                                        </div>
                                                    </div>
                                                    <div style={{display: 'flex', flex: 3, paddingLeft: 12,  flexDirection: 'column'}}>
                                                        <div style={{justifyContent: 'space-between', flexDirection: 'row', display: 'flex', flex: 1}}>
                                                            <Heading6 style={{color: colours.primary.grey01}}>{profile.First_Name} {profile.Last_Name}</Heading6>
                                                            {profile.Is_User !== 1 ? 
                                                                <Button small tertiary label="Edit" leading_ic="Edit" color={colours.primary.grey02} onClick={(e)=> {this.onEditInternalTag(e)}}/>
                                                                : null}
                                                        </div>
                                                        <div style={{marginTop: 8}}>
                                                            <P3 style={{color: colours.primary.grey02}}>
                                                                {profile.Title ? profile.Title : ''}
                                                            </P3>
                                                        </div>
                                                        <div style={{marginTop: 4}}>
                                                            <P3 style={{color: colours.primary.grey02}}>
                                                                {profile.Company ? profile.Company : ''}
                                                            </P3>
                                                        </div>
                                                        <div style={{marginTop: 16, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center'}}>
                                                            <div>
                                                                {profile.Email ? <div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center'}}>
                                                                    <Icon size={24} name="Email" style={iconContainerStyle}/>
                                                                    <CaptionMedium style={{color: colours.primary.grey02}}>Email:</CaptionMedium>
                                                                </div> : null}
                                                                {profile.phonenumbers && profile.phonenumbers.length > 0 ? <div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12}}>
                                                                    <Icon size={24} name="Phone" style={iconContainerStyle}/>
                                                                    <CaptionMedium style={{color: colours.primary.grey02}}>Phone Number:</CaptionMedium>
                                                                </div> : null}
                                                            </div>
                                                            <div>
                                                                {profile.Email ? <div style={{height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center'}}>
                                                                    <P3Bold style={{wordWrap: 'break-word', maxWidth: 250}}>{profile.Email}</P3Bold>
                                                                </div> : null}
                                                                {profile.phonenumbers && profile.phonenumbers.length > 0 ?<div style={{height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12}}>
                                                                    <P3Bold> {
                                                                        profile.phonenumbers[0].Country_Code + " (" + 
                                                                        profile.phonenumbers[0].Number.substring(0, 3) + ") " +
                                                                        profile.phonenumbers[0].Number.substring(3, 6) + "-" + 
                                                                        profile.phonenumbers[0].Number.substring(6) + 
                                                                        (profile.phonenumbers[0].Extension ? 'ext: ' + profile.phonenumbers[0].Extension : '')
                                                                    } </P3Bold>
                                                                </div> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 3} className="overlay_header_grid_item">
                                            <div className="overlay_header_bordered">
                                                <div style={{justifyContent: 'space-between', flexDirection: 'row', display: 'flex', flex: 1}}>
                                                    <Heading6 style={{color: colours.primary.grey01}}>User Settings</Heading6>
                                                    {profile.Is_User !== 1 ? 
                                                        <Button small tertiary label="Edit" leading_ic="Edit" color={colours.primary.grey02} onClick={(e)=> {this.onEditInternalTag(e)}}/>
                                                        : 
                                                        null}
                                                         {/* <Button small tertiary label="Edit" leading_ic="Edit" color={colours.primary.grey02} onClick={(e)=> {this.editProfile(e)}}/>} */}
                                                </div>
                                                <div style={{color: colours.primary.grey02, marginTop: 8, marginBottom: 8, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flex: 1, display: 'flex'}}>
                                                    <div style={{display: 'flex', flex: 1}}>
                                                        <CaptionMedium >TIER:</CaptionMedium>
                                                    </div>
                                                    <div style={{display: 'flex', flex: 1}}>
                                                        {
                                                            (profile.sh_vmh_access.length > 0 && profile.sh_vmh_access[0].tier) || (profile.sh_requests.length > 0 && profile.sh_requests[0].tier) ?
                                                            'sh_vmh_access' in profile && profile.sh_vmh_access.length > 0 && "tier" in profile.sh_vmh_access[0] ?
                                                            <Stars mutable confirmable type={"Profile"} ID={this.props.match.params.profile_id} star={(profile.sh_vmh_access[0].tier.Rank)}/>
                                                            : 'sh_requests' in profile && profile.sh_requests.length > 0 && "tier" in profile.sh_requests[0] ?
                                                            <Stars type={"Profile"} ID={this.props.match.params.profile_id} star={(profile.sh_requests[0].tier.Rank)}/>
                                                            : null
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                                {this.divisionsAndVcs()}
                                                <div style={{marginTop: 16, marginBottom: 8, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flex: 1, display: 'flex'}}>
                                                    <div style={{display: 'flex', flex: 1}}>
                                                        <CaptionMedium style={{color: colours.primary.grey02}}>MEMBER SINCE:</CaptionMedium>
                                                    </div>
                                                    <div style={{display: 'flex', flex: 1}}>
                                                        <P3Bold style={{color: colours.primary.black}}>{moment(profile.Created_At).format('MMM DD, YYYY')}</P3Bold>
                                                    </div>
                                                </div>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 3} className="overlay_header_grid_item">
                                            <div className="overlay_header_bordered">
                                                <div style={{justifyContent: 'space-between', flexDirection: 'row', display: 'flex'}}>
                                                    <Heading6 style={{color: colours.primary.grey01}}>Status</Heading6>
                                                    {this.state.profile_details.status && this.state.profile_details.status !== 'Inactive' ? 
                                                        <Button small tertiary label="Deactivate User" leading_ic="UserDeactivate" color={colours.primary.grey02} onClick={(e)=> {this.onDeactivate(e)}}/>
                                                        : <Button small tertiary label="Reactivate User" leading_ic="UserApprove" color={colours.primary.grey02} onClick={(e)=> {this.onReactivate(e)}}/>
                                                    }
                                                </div>
                                                <div style={{marginTop: 12}}>
                                                    <StatusCard type="user-active" user={this.props.stakeholder.current_profile_details} history={this.props.history} match={this.props.match} onReactivate={this.onReactivate} closeModal={this.props.closeModal}/>
                                                    <StatusCard type="user" user={this.props.stakeholder.current_profile_details} history={this.props.history} match={this.props.match} onReactivate={this.onReactivate} closeModal={this.props.closeModal}/>
                                                </div>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            </div>
                        </div>
                        <div className="overlay_tabs">
                            <div className={"overlay_tab_option" + (this.state.current_tab === "Overview" ? " overlay_tab_active" : "")} onClick={() => this.setTab("Overview")}>
                                <Icon name="Overview" size={24} style={{color: this.state.current_tab === "Overview" ? colours.primary.blue : colours.primary.grey02, marginRight: 4}}/>
                                Overview
                            </div>
                            <div className={"overlay_tab_option" + (this.state.current_tab === "Bookings" ? " overlay_tab_active" : "")} onClick={() => this.setTab("Bookings")}>
                                <Icon name="Booking" size={24} style={{color: this.state.current_tab === "Bookings" ? colours.primary.blue : colours.primary.grey02, marginRight: 4}}/>
                                Bookings
                            </div>
                            {
                                this.props.stakeholder.current_profile_details.user_type == "user" ?
                                    <div className={"overlay_tab_option" + (this.state.current_tab === "Surveys" ? " overlay_tab_active" : "")} onClick={() => this.setTab("Surveys")}>
                                        <Icon name="Survey" size={24} style={{color: this.state.current_tab === "Surveys" ? colours.primary.blue : colours.primary.grey02, marginRight: 4}}/>
                                        Survey
                                    </div>
                                :
                                    null
                            }             
                            {
                                this.state.media_user ? 
                                    <div className={"overlay_tab_option" + (this.state.current_tab === "Media" ? " overlay_tab_active" : "")} onClick={() => this.setTab("Media")}>
                                        <Icon name="Media" size={24} style={{color: this.state.current_tab === "Media" ? colours.primary.blue : colours.primary.grey02, marginRight: 4}}/>
                                        Media
                                    </div>
                                :
                                    null
                            }
                            
                        </div>
                        {
                            this.state.loading_main ? 
                                <LoadingIcon />
                            :
                                this.renderTab()
                        }
                        
                    </div>
                )
            }
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ProfileOverlay)